/*
 * @Author: your name
 * @Date: 2022-01-26 13:48:49
 * @LastEditTime: 2022-01-27 09:20:31
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \zhijixiehui-homepage\src\pages\index\models\map.ts
 */

export class ProvinceData {
  name: string
  value: number
  constructor (name: string, value: number) {
    this.name = name
    this.value = value
  }
}

export class MapData {
  memberTotal: Array<ProvinceData>
  standingDirectorUnit: Array<ProvinceData>
  councilMembers: Array<ProvinceData>
  memberUnit: Array<ProvinceData>
  constructor (
    memberTotal: Array<ProvinceData>,
    standingDirectorUnit: Array<ProvinceData>,
    councilMembers: Array<ProvinceData>,
    memberUnit: Array<ProvinceData>
  ) {
    this.memberTotal = memberTotal
    this.standingDirectorUnit = standingDirectorUnit
    this.councilMembers = councilMembers
    this.memberUnit = memberUnit
  }
}

export class Unit {
  name: string
  url: string
  type: string
  constructor (
    name: string,
    url: string,
    type: string
  ) {
    this.name = name
    this.url = url
    this.type = type
  }
}
